import React from 'react';
import './ExperiencePage.css';
import { useLanguage } from '../i18n/LanguageContext';
import { useTheme } from '../contexts/ThemeContext';
import { getExperiencesWithTranslations } from '../data/experienceData';
import Header from '../components/Header/Header';
import Footer from '../components/Footer/Footer';

const ExperienceCard = ({ logo, position, company, items, period }) => (
  <div className="experience-page__card" data-name="Row">
    <div className="experience-page__card-header">
      <div className="experience-page__card-logo">
        <img src={logo} alt={company} />
      </div>
      <div className="experience-page__card-info">
        <h3 className="experience-page__card-title">{position}</h3>
        <ul className="experience-page__card-items">
          {items.map((item, index) => (
            <li key={index} className="experience-page__card-item">
              {item}
            </li>
          ))}
        </ul>
      </div>
      <div className="experience-page__card-period">
        <p className="experience-page__card-period-text">{period}</p>
      </div>
    </div>
  </div>
);

const ExperiencePage = () => {
  const { t, language } = useLanguage();
  const { theme } = useTheme();
  const experienceData = getExperiencesWithTranslations(language, theme);

  return (
    <div className="experience-page-wrapper">
      <Header />
      
      <main className="experience-page">
        <div className="experience-page__container">
          {/* Header */}
          <div className="experience-page__header">
            <div className="experience-page__header-inner">
              <div className="experience-page__tag">
                <p className="experience-page__tag-text">{t('experiencePage.tag')}</p>
              </div>
            </div>

            <div className="experience-page__header-subtitle">
              <h1 className="experience-page__title">
                {t('experiencePage.title')}
              </h1>
              <p className="experience-page__subtitle">
                {t('experiencePage.description')}
              </p>
            </div>
          </div>

          {/* Experience Cards */}
          <div className="experience-page__list">
            {experienceData.map((exp) => (
              <ExperienceCard
                key={exp.id}
                logo={exp.logo}
                position={exp.position}
                company={exp.company}
                items={exp.items}
                period={exp.period}
              />
            ))}
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ExperiencePage;
